import { StatusEnum } from "./status-enum";

export const salesRequestStatusLabels = {
  [StatusEnum.PENDING]: "Pending",
  [StatusEnum.PARTIALLY_ORDERED]: "Dipesan Sebagian",
  [StatusEnum.FULLY_ORDERED]: "Dipesan Penuh",
};
